import { render, staticRenderFns } from "./MarketingSectionItem.vue?vue&type=template&id=518ad789&scoped=true&"
import script from "./MarketingSectionItem.vue?vue&type=script&lang=js&"
export * from "./MarketingSectionItem.vue?vue&type=script&lang=js&"
import style0 from "./MarketingSectionItem.vue?vue&type=style&index=0&id=518ad789&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518ad789",
  null
  
)

export default component.exports